$(document).ready(function () {

	$('[data-trigger-form]').change(function () {
		var id = $(this).attr('form');
		var $form = $('#'+id);
		$form.trigger('submit');
	});

});